/* eslint-disable */
// ImportantBar — the `important` tier's surface. A single fixed line beneath the
// header, held until dismissed.
//
// ⚠️ It sits UNDER the header, never over it. Hiding navigation to show a
// notification trades one problem for a worse one. And it is `position: fixed`,
// so it never pushes the page down on arrival — a layout jump while someone is
// reading is its own defect.
//
// ⚠️ ONE TIER, ONE SURFACE. An `important` notification renders here and NOT as a
// corner card; useNotifications' `cards` array is `normal` only. The same message
// in two places reads as a bug and trains people to dismiss twice.
//
// Newest wins: if a second important arrives while one is showing, it replaces the
// visible bar and the older stays unread in the drawer. Bars do not stack — two
// stacked bars would eat the screen and reintroduce the layout shift.

import React, { useState } from 'react';
import { useNotifications } from '../../hooks/useNotifications';
import { canOpenNotification, openNotification } from '../../utils/entityRoutes';
import styles from './severity.module.css';

const Glyph = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 9v4" /><path d="M12 17h.01" />
    <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
  </svg>
);

export function ImportantBar() {
  const { important, markRead } = useNotifications();
  const [leaving, setLeaving] = useState(false);

  // Newest first from the query, so [0] is the one that shows.
  const row = important[0];
  if (!row) return null;

  const n = row.notifications;
  const showOpen = canOpenNotification(n);

  const dismiss = () => {
    if (leaving) return;
    setLeaving(true);
    setTimeout(() => { markRead(row.id); setLeaving(false); }, 200);
  };

  const open = () => {
    // Navigating always stamps read_at — the person went and looked.
    if (openNotification(n)) { markRead(row.id); }
  };

  return (
    <div className={styles.sevRoot}>
      <div
        className={`${styles.bar}${leaving ? ' ' + styles.leaving : ''}`}
        role="status"
        data-test="important-bar"
        data-severity="important"
      >
        <span className={styles.barGlyph}><Glyph /></span>
        <span className={styles.barTitle} dir="auto" data-test="important-bar-title">{n.title}</span>
        {/* one line, ellipsis at the bar's width — it never wraps to two */}
        {n.body && <span className={styles.barBody} dir="auto">{n.body}</span>}
        <span className={styles.barBtns}>
          {showOpen && (
            <button type="button" className={styles.barOpen} onClick={open} data-test="important-bar-open">
              Open
            </button>
          )}
          <button
            type="button"
            className={styles.barClose}
            onClick={dismiss}
            aria-label="Dismiss"
            data-test="important-bar-close"
          >×</button>
        </span>
      </div>
    </div>
  );
}

export default ImportantBar;
